import { render, staticRenderFns } from "./EchartDoughnut.vue?vue&type=template&id=4f8918fe"
import script from "./EchartDoughnut.vue?vue&type=script&lang=js"
export * from "./EchartDoughnut.vue?vue&type=script&lang=js"
import style0 from "./EchartDoughnut.vue?vue&type=style&index=0&id=4f8918fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports